import { gql } from '@apollo/client';

const queryRequestInfo = (shareUri: string) => {
    return {
        variables: {
            shareUri,
        },
        query: gql`
            query getShareObject($shareUri: String!) {
                getShareObject(shareUri: $shareUri) {
                    approver
                    owner
                    samlGroupName
                    environmentName
                    orgaName
                    shareAccounts
                    userRoleForShareObject
                    principal {
                        region
                    }
                }
            }
        `,
    };
};

export default queryRequestInfo;
